import type { AiBusinessCenterModule } from '../types'

/** 档案管理独立应用配置。 */
export const archiveModule: AiBusinessCenterModule = {
  key: 'archive',
  label: '档案管理',
  desc: '档案门类/案卷/文件/借阅/鉴定/销毁/编研/移交/数字化',
  path: '/archive',
  homePath: '/archive/category',
  icon: 'ep:collection',
  color: '#8b5cf6'
}
